export default __webpack_public_path__ + "static/media/logo-Final.3832b570.png";